import React from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Problema from "../components/landing/Problema";
import ComoFunciona from "../components/landing/ComoFunciona";
import DentrIA from "../components/landing/DentrIA";
import MeuFiltro from "../components/landing/MeuFiltro";
import MinhaMeta from "../components/landing/MinhaMeta";
import Resultado from "../components/landing/Resultado";
import Beneficios from "../components/landing/Beneficios";
import ParaQuem from "../components/landing/ParaQuem";
import Download from "../components/landing/Download";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
    return (
        <div
            className="min-h-screen bg-white text-[#0B1C3A] overflow-x-hidden"
            data-testid="landing-root"
        >
            <Header />
            <main>
                <Hero />
                <Problema />
                <ComoFunciona />
                <DentrIA />
                <MeuFiltro />
                <MinhaMeta />
                <Resultado />
                <Beneficios />
                <ParaQuem />
                <Download />
            </main>
            <Footer />
        </div>
    );
}
